var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0.707581C24.9429 0.707581 19.0219 2.50371 13.9857 5.86882C8.9494 9.23394 5.02412 14.0169 2.70619 19.6129C0.388254 25.2089 -0.218223 31.3666 0.963449 37.3072C2.14512 43.2479 5.06187 48.7047 9.34485 52.9877C13.6278 57.2707 19.0847 60.1875 25.0254 61.3691C30.966 62.5508 37.1237 61.9443 42.7197 59.6264C48.3157 57.3085 53.0986 53.3832 56.4638 48.3469C59.8289 43.3107 61.625 37.3896 61.625 31.3326C61.625 23.2103 58.3984 15.4207 52.6551 9.67743C46.9118 3.93413 39.1223 0.707581 31 0.707581ZM47.2903 33.2904L21.0403 46.4154C20.7067 46.5821 20.3361 46.6607 19.9635 46.6439C19.591 46.627 19.229 46.5152 18.9118 46.319C18.5947 46.1228 18.3329 45.8488 18.1515 45.5231C17.97 45.1973 17.8748 44.8305 17.875 44.4576V18.2076C17.8752 17.8349 17.9706 17.4684 18.1523 17.1429C18.3339 16.8174 18.5956 16.5437 18.9127 16.3478C19.2298 16.1519 19.5917 16.0402 19.9641 16.0235C20.3364 16.0067 20.7069 16.0853 21.0403 16.252L47.2903 29.377C47.6532 29.5588 47.9583 29.8381 48.1715 30.1834C48.3847 30.5288 48.4977 30.9267 48.4977 31.3326C48.4977 31.7385 48.3847 32.1364 48.1715 32.4817C47.9583 32.8271 47.6532 33.1063 47.2903 33.2882",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).c58be3c37a1c7cf6650571bc4946eb55.svg";
export { ForwardRef as ReactComponent };